import PlanningCommissionMembership from "../board-memberships/PlanningCommissionMembership";
import PCEntries from "../docs-archive-elements/PCEntries";
export default function PlanningDetails() {
  return (
    <div>
      <div className="government-bg bg-image">
        <div className="gap-spacer"></div>
        <div className="page-title top-cap-outlines">
          <h2>Planning Commission</h2>
        </div>

        {/*End Large Image Space*/}

        {/*Start Main Content*/}
        <div className="content-fluid">
          <div className="mb-960-center-container mid-side-outlines">
            {/*Full Width Element*/}
            <div className="mb-960-col-50p">
              <div className="council-members">
                <h4>Meetings</h4>
                <ul>
                  <li>7:00 p.m.</li>
                  <li>2nd Monday of the month</li>
                  <li>
                    <a href="https://maps.app.goo.gl/RjUcQgXYQvFVtETj8">
                      <i className="fa-solid fa-location-pin"></i>&nbsp;Borough Hall
                      <br />
                      35 Union Street
                      <br />
                      Morrisville, PA 19067
                    </a>
                    <br />
                  </li>
                </ul>
                <h4>Composition</h4>
                <ul>
                  <li>5 Members</li>
                  <li>4 year terms</li>
                  <li>Terms expire on the last day of December</li>
                </ul> 
              </div>
              {/*Start Accordion*/}
              <div className="container accordion-container">
                <div className="accordion" id="PlanningAccordion">
                  {/* Item Start */}
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <button
                        className="accordion-button caret-off collapsed darkblue-item button-full-width"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapsePlanning01"
                      >
                        <div>
                          <i className="fa-solid fa-scroll fa-2xl feature-icon af-icon"></i>
                        </div>
                        <div>
                          <b>Purpose</b>
                        </div>
                      </button>
                    </h2>
                    <div
                      id="collapsePlanning01"
                      className="accordion-collapse collapse"
                      data-bs-parent="PlanningAccordion"
                    >
                      <div className="accordion-body">
                        <p>
                          Communities throughout the commonwealth are faced with
                          many challenges that require the insight,
                          intuitiveness and energy of its local residents, some
                          of whom are appointed by their governing body to serve
                          on their municipal planning commission. These “citizen
                          planners” are tasked with developing plans and
                          implementation policies that provide the foundation
                          for the community to manage changes caused by a
                          variety of internal and external forces including
                          community growth or decline, and changes in
                          demographics, economies, technology, natural
                          resources, the environment, housing, transportation,
                          etc.
                        </p>
                        <p>
                          As its name implies, a planning commission's primary
                          activity is planning, which according to the American
                          Planning Association, “is a dynamic discipline that
                          works to improve the welfare of people and their
                          communities by creating more convenient, equitable,
                          healthful, efficient, and attractive places for
                          present and future generations. Planning enables civic
                          leaders, businesses, and citizens to play a meaningful
                          role in creating communities that enrich people's
                          lives. Good planning helps create communities that
                          offer better choices for where and how people live.
                          Planning helps communities to envision their future.
                          It helps them find the right balance of new
                          development, essential services, environmental
                          protection and innovative change.”
                        </p>
                        <p>
                          In Pennsylvania, planning commissions are primarily
                          responsible for and charged with exercising a
                          municipality's legal right to develop a comprehensive
                          plan that outlines its specific community planning
                          objectives that may focus on environmental protection;
                          agricultural, historical, and cultural resource
                          preservation; business retention, expansion, and
                          recruitment; urban redevelopment; housing
                          opportunities; parks and recreation amenities;
                          transportation and utility infrastructure; or other
                          health, safety, and public welfare needs and issues
                          that are critical to a community's overall well-being
                          and prosperity.
                        </p>
                        <p>
                          As such, planning commissions are on the front line
                          regarding the issues that matter most to many
                          communities. Their leadership is crucial in developing
                          recommendations for implementing change as well as
                          promoting responsible and sustainable community
                          planning practices that have not only local
                          implications, but multimunicipal and regional
                          implications as well. The position is a four (4) year
                          term expiring the first Monday in January.
                        </p>
                      </div>
                    </div>
                    
                    
                  </div>
                  {/* Item Finish */}
                    {/* Item Start */}
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <button className="accordion-button caret-off collapsed darkblue-item button-full-width" type="button" data-bs-toggle="collapse" data-bs-target="#collapseBoardApply">
                        <div>
                          <i className="fa-solid fa-person-circle-plus fa-2xl feature-icon af-icon"></i>
                        </div>

                        <div>
                          <b>Apply To Join The Board</b>
                        </div>
                      </button>
                    </h2>
                    <div id="collapseBoardApply" className="accordion-collapse collapse" >
                      <div className="accordion-body">
                        Please send letters of interest to:<br/> <a href="mailto:office@morrisvilleboro.org">
                    <i className="fa-solid fa-envelope"></i>
                    &nbsp;office@morrisvilleboro.org
                  </a>
                      </div>
                    </div>
                  </div>
                  {/* Item Finish */}
                </div>
              </div>
              {/*Accordion Finish*/}
            </div>

            <div className="mb-960-col-50p">
              <div className="council-members">
               <PlanningCommissionMembership/>
                

                <h4>Related Documents</h4>
               <PCEntries />
              </div>
            </div>
          </div>
        </div>
        <div className="page-footer bottom-cap-outlines">&nbsp;</div>
        <div className="gap-spacer"></div>
      </div>
    </div>
  );
}
